import React from 'react';
import CommonPanel from '../Common/CommonPanel';
import BatchEdit from './BatchEdit';
import Button from '../Field_Components/Button/Button';
import { Nav, Footer, SafeAreaWrap } from '@beisen/chaos-ui';
import {
    ifHidePopupNav,
    generateHeaderConfig,
    clearHeaderConfig
} from '../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
import classNames from 'classNames';
import { addEnNavClassName } from '../util/ui';
require('./BatchEdit.scss');

const defaultTranslation = {
    confirm: '确定',
    letField: '将字段',
    required: '必填',
    cancel: '取消'
};
export default class BatchEditWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.saveBatchEditData = this.saveBatchEditData.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            confirm: 'common.confirm',
            letField: 'fieldPlaceHolder.letField',
            required: 'common.required',
            cancel: 'common.cancel'
        }), props.translation);
    }

    cancelEdit() {
        this.props.actions.clearBatchEditState();
        this.props.actions.btnClearFn();
        this.props.clearTipHandler && this.props.clearTipHandler();
    }

    getContent() {
        return <BatchEdit ref="batchEdit" {...this.props} translation={this.translation} />;
    }

    getFooter() {
        const { translation } = this;
        return (
            <Footer>
                <SafeAreaWrap safeAreaStyle={{ background: '#f5f6f7' }}>
                    <Button
                        type="primary"
                        cmp_label={translation.confirm}
                        onTouchTap={this.saveBatchEditData}
                    />
                </SafeAreaWrap>
            </Footer>
        );
    }

    saveBatchEditData() {
        this.refs.batchEdit.save();
    }

    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        let title = this.props.popOptions.params.title;
        generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'batchEditWrapperCancel',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);

            if (title) {
                config.titleItem = {
                    text: title,
                    icon: '',
                    callback: '',
                    control: false
                };
            }
            return config;
        });
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        clearHeaderConfig();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager[
            'batchEditWrapperCancel'
        ] = this.cancelEdit.bind(this);
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['batchEditWrapperCancel'];
    }

    componentDidMount() {
        if (ifHidePopupNav()) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    render() {
        const popOptions = Object.assign(
            {
                visible: true,
                animation: 'bottom-slide-fade',
                maskAnimation: 'fade',
                cls: 'editOwnerform_popup form_popup',
                lazyRender: true,
                maskClosable: false
            },
            this.props.popOptions
        );

        const { translation } = this;

        const pageOptions = {
            cls: 'edit-form batchEdit'
        };
        let navStyle = ifHidePopupNav() ? { display: 'none' } : {};
        const enNavButtonClass = addEnNavClassName();
        const nav = (<Nav cls="editform-navbar" title={this.props.popOptions.params.title} style={navStyle}>
            <a role="left" href='javascript:;' className={classNames('editform-cancle-btn', enNavButtonClass)} onTouchTap={this.cancelEdit}>{translation.cancel}</a>
        </Nav>);

        return (<CommonPanel
            popOptions={popOptions}
            pageOption={pageOptions}
            nav={nav}
            content={this.getContent()}
            footer={this.getFooter()}
        ></CommonPanel>);
    }
}



// WEBPACK FOOTER //
// ./src/components/BatchEdit/BatchEditWrapper.js